const QUARTERS = [
  { label: "Q1", month: 0 },
  { label: "Q2", month: 3 },
  { label: "Q3", month: 6 },
  { label: "Q4", month: 9 },
];

export function getDateOptions() {
  const today = new Date();
  const year = today.getFullYear();
  const quarters = QUARTERS
    .filter(({ month }) => today >= new Date(year, month, 1))
    .map(({ label }) => label);
  const inQ1 = today.getMonth() < 3;
  return ["This Week", "Last Week", "MTD", "Last Month", ...(inQ1 ? ["Last Quarter"] : []), ...quarters, "Custom Range"];
}
